import { action } from 'satcheljs';
import type { ComposeViewState } from 'owa-mail-compose-store';

export interface OnEditorFocusedActionMessage {
    viewState: ComposeViewState;
    targetWindow: Window;
}
const onEditorFocused: (
    viewState: ComposeViewState,
    targetWindow: Window
) => OnEditorFocusedActionMessage = action(
    'OnEditorFocused',
    (viewState: ComposeViewState, targetWindow: Window): OnEditorFocusedActionMessage => ({
        viewState,
        targetWindow,
    })
);

export default onEditorFocused;
